let custom;

document.addEventListener("DOMContentLoaded", () => {
  const modal_button = document.querySelector("#rsce_consulting_modal_button");
  const close_button = document.querySelector("#rsce_consulting_modal_close");
  const modal_overlay = document.querySelector("#rsce_consulting_modal_overlay");
  const body = document.querySelector("body");
  const modal = document.querySelector("#rsce_consulting_modal");

  if (document.querySelector("#rsce_consulting_modal")) {
    modal_button.addEventListener("click", e => {
      e.preventDefault();
      modal.style.display = "block";
      modal.showModal();
    });
  }
  if (document.querySelector("#rsce_consulting_modal_overlay")) {
    modal_overlay.addEventListener("click", e => {
      e.preventDefault();
      modal.close();
    });
  }
  if (document.querySelector("#rsce_consulting_modal_close")) {
    close_button.addEventListener("click", e => {
      e.preventDefault();
      modal.close();
    });
  }
  function close_modal() {
    modal.close();
  }
  function open_modal() {
    modal.showModal();
  }
});

export default custom;